import React , {useEffect} from "react";
import { Class_ETC_MsgSessionTimeOut } from "../Class/Class_Etc";


function Timeout() {
  
  useEffect(() => {
    Class_ETC_MsgSessionTimeOut()
  }, []);


  return (
    <>

    </>
  );
}

export default Timeout;
